// extracted by mini-css-extract-plugin
export default {"resultsByDimension_container":"ResultsByDimension_resultsByDimension_container__b5zgG"};